// src/services/assessmentService.js

//import { auth } from '../config/firebase';

const API_BASE_URL = 'https://your-cloud-function-base-url.com'; // Replace with your actual base URL

export const assessmentService = {
/*
  async getRecommendation(answers, userContext = {}) {
    try {
      // Get current user token for authentication
      const user = auth.currentUser;
      if (!user) {
        throw new Error('User must be authenticated');
      }

      const token = await user.getIdToken();
      
      const response = await fetch(`${API_BASE_URL}/assessmentRecommender`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          answers,
          userContext
        })
      });

      if (!response.ok) {
        throw new Error(`API call failed: ${response.statusText}`);
      }

      const result = await response.json();
      
      if (result.success) {
        return result.data.recommendation;
      } else {
        throw new Error(result.message || 'Failed to get recommendation');
      }
      
    } catch (error) {
      console.error('Assessment service error:', error);
      throw error;
    }
  },
*/
  // Alternative: If your cloud function is callable via HTTPS
  async getRecommendationCallable(answers, userContext = {}) {
    try {
      const user = "roopesh"; //auth.currentUser;
      if (!user) {
        throw new Error('User must be authenticated');
      }

      const token = await user.getIdToken();
      
      const response = await fetch(`${API_BASE_URL}/api/assessment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          data: {
            answers,
            userContext
          }
        })
      });

      if (!response.ok) {
        throw new Error(`API call failed: ${response.statusText}`);
      }

      const result = await response.json();
      return result.data.recommendation;
      
    } catch (error) {
      console.error('Assessment service error:', error);
      throw error;
    }
  }
};

// Fallback recommendation generator
export const getFallbackRecommendation = (answers) => {
  const { skill, experience, confidence } = answers;
  
  const isExperienced = (
    skill === 'advanced' || 
    skill === 'intermediate' ||
    experience === 'hasProjects' || 
    confidence >= 7
  );
  
  return {
    track: isExperienced ? 'EXPERIENCED' : 'BEGINNER',
    confidence: 'MEDIUM',
    reasoning: isExperienced ? 'fallback_experienced' : 'fallback_beginner',
    personalizedMessage: `Based on your assessment, we recommend the ${isExperienced ? 'Experienced' : 'Beginner'} track to help you achieve your goals.`,
    keyStrengths: ['Motivation to learn AI', 'Clear goals'],
    areasForGrowth: ['Technical foundation', 'Project experience'],
    learningPath: {
      duration: isExperienced ? '3-4 months' : '5-6 months',
      focusAreas: ['AI Fundamentals', 'Practical Projects', 'Career Preparation'],
      expectedOutcomes: ['Solid understanding', 'Portfolio project', 'Career readiness']
    },
    nextSteps: ['Review track details', 'Schedule consultation', 'Start learning']
  };
};